import React from 'react';
import { motion } from 'framer-motion';
import FlipCard from '../FlipCard/FlipCard';
import ListingFront from './ListingFront';
import ListingBack from './ListingBack';
import { TooltipContext } from './TooltipContext';
import logo from '../../assets/images/logo.png';
import './FlippableListingCard.css';

const FlippableListingCard = ({ profile = {}, isCertified = false }) => {
  const [openId, setOpenId] = React.useState(null);
  
  // Check if the card has meaningful back content that requires flipping
  const hasClinicalContent = () => {
    const clinicalCaseTypes = profile.clinicalExpectations?.requiredCaseTypes?.length > 0;
    const hasEmr = profile.clinicalExpectations?.emrSystem && 
                  profile.clinicalExpectations.emrSystem !== '–';
    const hasWebsite = profile.website && profile.website !== '–';
    const includesHousing = profile.includesHousing || profile.compensation?.includesHousing;
    const includesTravel = profile.includesTravel || profile.compensation?.includesTravel;
    const malpracticeCovered = profile.malpracticeCovered || profile.compensation?.malpracticeCovered;
    const hasPerks = includesHousing || includesTravel || malpracticeCovered;
    
    // Only make flippable if there's actually content on the back worth showing
    return clinicalCaseTypes || hasEmr || hasWebsite || hasPerks;
  };
  
  const needsFlipping = hasClinicalContent();

  return (
    <TooltipContext.Provider value={{ openId, setOpenId }}>
      <motion.div
        className="listing-card-wrapper"
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        whileHover={{ scale: 1.03 }}
        transition={{ type: 'spring', stiffness: 280, damping: 20 }}
        aria-label="Listing Card"
      >
        <FlipCard
          flippable={needsFlipping}
          front={
            <ListingFront 
              profile={profile} 
              isCertified={isCertified} 
              showClinicalInfo={!needsFlipping} 
            />
          }
          back={<ListingBack profile={profile} isCertified={isCertified} />}
          footer={
            <div className="card-footer-logo">
              <img src={logo} alt="RxRooster Logo" width={64} />
            </div>
          }
        />
      </motion.div>
    </TooltipContext.Provider>
  );
};

export default FlippableListingCard;
